import { Platform } from "react-native";
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, MessageAlignType, ProgressIndicatorTypeTokens, ShimmerIconSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StepperTypeTokens, WIDGET } from "@voltmoney/schema";
import { POSITION } from "@voltmoney/types";
import { ACTION } from "../loanAgreement/loan_agreement_poll/types";
import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { CreditApplicationStepId } from "../../configs/constants";
export const renderAgreementLoaderLayout = async (isPollingForSFDCGeneration) => {
    return isPollingForSFDCGeneration ? [
        Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
        {
            id: 'headerStack',
            type: WIDGET.HEADER,
            position: POSITION.ABSOLUTE_TOP,
        },
        { id: 'headerSpace', type: WIDGET.SPACE },
        { id: 'headerSpace1', type: WIDGET.SPACE },
        { id: 'iconSpace', type: WIDGET.SPACE },
        { id: 'progressItem', type: WIDGET.PROGRESSINDICATOR },
        { id: 'progressSpace', type: WIDGET.SPACE },
        { id: 'contentStack', type: WIDGET.STACK },
        { id: 'contentSpace', type: WIDGET.SPACE },
        {
            id: 'secureText',
            type: WIDGET.MESSAGE,
            position: POSITION.ABSOLUTE_BOTTOM,
            padding: {
                all: 0,
                left: 0,
                right: 0,
                horizontal: 0,
            },
        },
    ] : [];
};
export const renderAgreementLoaderDataStore = async (stepper) => {
    return {
        headerStack: {
            leadIcon: 'https://reactnative.dev/img/tiny_logo.png',
            title: 'Setup Agreement',
            isBackButton: true,
            type: HeaderTypeTokens.verification,
            stepperProps: {
                type: StepperTypeTokens.HORIZONTAL,
                data: stepper,
            },
            action: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                payload: {},
            },
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        },
        loanPolePage: {},
        headerSpace: { size: SizeTypeTokens.XXXXXXL },
        headerSpace1: { size: SizeTypeTokens.XXXL },
        iconStack: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [{ id: 'iconItem', type: WIDGET.SHIMMERICON }],
        },
        iconItem: {
            icon: {
                name: IconTokens.FreeBook,
                size: IconSizeTokens.XXXXXXXXL,
            },
            name: 'Freebook',
            size: ShimmerIconSizeTokens.XXXXXL,
            borderRadius: BorderRadiusTokens.BR0,
            padding: SizeTypeTokens.SM,
        },
        iconSpace: { size: SizeTypeTokens.XXXXL },
        progressItem: {
            activeIndex: 1,
            type: ProgressIndicatorTypeTokens.LINEAR,
        },
        progressSpace: { size: SizeTypeTokens.XXXL },
        contentStack: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'titleItem', type: WIDGET.TEXT },
                { id: 'Space0', type: WIDGET.SPACE },
                { id: 'description', type: WIDGET.TEXT },
            ],
        },
        titleItem: {
            label: 'Generating Agreement link',
            color: ColorTokens.Grey_Night,
            fontSize: FontSizeTokens.SM,
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
        },
        Space0: { size: SizeTypeTokens.XS },
        description: {
            label: 'We’re verifying your details. It may take up to 60 seconds',
            color: ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
        },
        contentSpace: { size: SizeTypeTokens.XXXXXXL },
        bottomCard: {
            bgColor: ColorTokens.White,
            body: {
                widgetItems: [
                    { id: 'secureText', type: WIDGET.MESSAGE },
                    // {
                    //     id: "infoStack",
                    //     type: WIDGET.STACK,
                    //   },
                    //  { id: "bottomCard2Details", type: WIDGET.STACK }
                ],
            },
        },
        // infoStack: <StackProps>{
        //   type: StackType.row,
        //   width: StackWidth.FULL,
        //  // height: StackHeight.CONTENT,
        //   // justifyContent: StackJustifyContent.center,
        //   // alignItems: StackAlignItems.center,
        //   widgetItems: [{ id: "secureText", type: WIDGET.MESSAGE }],
        // },
        secureText: {
            label: 'Do not leave at this step',
            labelColor: ColorTokens.Grey_Charcoal,
            bgColor: ColorTokens.Primary_02,
            alignText: MessageAlignType.CENTER,
        }
    };
};
export const checkApplicationStatusForKFS = async ({ network, applicationId, isPollingForSFDCGeneration, navigateWithClear, poll_interval, shouldNavigate }) => {
    const getApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, {
        headers: await getAppHeader()
    }, async () => { return; }, {
        handleFromMF: true
    });
    if (getApplicationResponse?.status === 200) {
        if (getApplicationResponse?.data?.currentStepId === CreditApplicationStepId.CREDIT_APPROVAL) {
            isPollingForSFDCGeneration = true;
        }
        else {
            poll_interval && clearInterval(poll_interval);
            isPollingForSFDCGeneration = false;
            if (shouldNavigate) {
                await navigateWithClear(ROUTE.BAJAJ_AGREEMENT_STEPPER, { shouldPool: false });
                return isPollingForSFDCGeneration;
            }
        }
    }
    return isPollingForSFDCGeneration;
};
